//------Gigya code for contact Page starts------//
var contact_header_value = {
  isoLanguage: "en",
  isoCountry: "IN",
  brandCode: "BHA361",
  brandDescription: "Liquid I.V.",
  formID: "7cc1cdba",
  campaignId: "PN007080",
  campaignURL: "https://campaignwizard.unilever.com/campaign-wizard/campaign/7cc1cdba",
  campaignDescription: "Liquid I.V.",
  origin: "https://liquid-iv.co.in/",
  formType: "signUp",
  entity: "PRM2.6",
};
// console.log("gigya_contact_header_value: ", contact_header_value);
$(document).ready(function() {
  $("body").on("click", "#contact-form-button", function(e) {
    e.preventDefault();
    $(".error_msg").text(""); // Clear previous error messages
    if (validateContactForm()) {
      console.log("Validation passed!");
      if (typeof gigya_contact_code === "function") {
        gigya_contact_code(contact_header_value);
      } else {
        console.error("Gigya function is not defined.");
      }
    } else {
      console.log("Validation failed.");
    }
  });
});

function validateContactForm() {
  var name = $("#ContactForm-name").val().trim();
  var email = $("#ContactForm-email").val().trim();
  var remarks = $("#ContactForm-body").val().trim();
  var consentChecked = $("#consent-contact-checkbox").is(":checked");
  if (!email || !consentChecked) {
    $(".error_msg").text("Fields marked with an asterisk are required.");
    return false;
  }
  return true;
}

function gigya_contact_code(contact_header_value) {
  var name = $("#ContactForm-name").val().trim();
  var email = $("#ContactForm-email").val().trim();
  var remarks = $("#ContactForm-body").val().trim();
  var consentChecked = $("#consent-contact-checkbox").is(":checked");
  var optInStatus_value = {
    legalAgeConsent: consentChecked,
    unileverEmailConsent: consentChecked,
    unileverSMSConsent: consentChecked,
  };
  var data_value = JSON.stringify({
    profile: {
      header: contact_header_value,
      consumerIdentity: {
        name: name,
      },
      contactDetail: {
        email: email,
      },
      otherDetail: {
        consumerRemarks: remarks,
      },
      optInStatus: optInStatus_value,
    },
  });
  console.log("gigya_contact_data_value: ", data_value);
  var settings = {
    url: "https://forms-sg.unileversolutions.com/v3",
    method: "POST",
    timeout: 0,
    headers: {
      // "x-api-key": "4443838a-d79e-46bf-b745-08c826f64c1a",
      "x-api-key": "77f1e0f0-0118-4437-b208-5118ca844e29",
      "Content-Type": "application/json",
    },
    data: data_value,
  };
  $.ajax(settings).done(function(response) {
    console.log("Pass response: ", response);
    createContactCookie(response);
    $("form#ContactForm").submit();
    $("form#ContactForm button.submit").text("Processing..");
  }).fail(function(response) {
    console.log("Fail response: ", response.responseText);
    var errorObject = JSON.parse(response?.responseText);
    $(".error_msg").text(errorObject.downstreamApiResponse?.Value || "An error occurred. Please try again.");
    $(".form#ContactForm button.submit").text("Submit");
  });
}

function createContactCookie(id) {
  console.log("Success:", id);
  const d = new Date();
  d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = "UnileverId=" + id["UnileverId"] + ";" + expires + ";path=/";
}
//------Gigya code for contact Page ends------//